// BrandsSection.js
import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCreative } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-creative";
import "./BrandsSection.css";

const BrandsSection = ({ logos }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("brands-visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="home-brands-wrapper" ref={sectionRef}>
      {/* Background gradient effect */}
      <div className="brands-bg-glow"></div>
      
      {/* Section Header */}
      <div className="brands-header">
        <div className="brands-header-badge">
          <span className="brands-badge-icon">✦</span>
          <span>Our Partners</span>
        </div>
        <h2 className="brands-title">
          Trusted By 
          <span className="brands-title-gradient"> Leading Brands</span>
        </h2>
        <p className="brands-subtitle">
          We partner with the most trusted names in the fireworks industry
        </p>
      </div>

      {/* Marquee Style Carousel */}
      <div className="brands-carousel-container">
        <div className="brands-marquee">
          <div className="brands-marquee-content">
            {/* First set of logos */}
            {logos.map((logo, idx) => (
              <div key={`first-${idx}`} className="brands-logo-item">
                <div className="brands-logo-card">
                  <img 
                    src={logo.image} 
                    alt={`Brand ${idx + 1}`} 
                    className="brands-logo-image"
                    loading="lazy"
                  />
                  <div className="brands-logo-overlay">
                    {/* <span>Premium Partner</span> */}
                  </div>
                </div>
              </div>
            ))}
            {/* Duplicate for seamless loop */}
            {logos.map((logo, idx) => (
              <div key={`second-${idx}`} className="brands-logo-item">
                <div className="brands-logo-card">
                  <img 
                    src={logo.image} 
                    alt={`Brand ${idx + 1}`} 
                    className="brands-logo-image"
                    loading="lazy"
                  />
                  <div className="brands-logo-overlay">
                    {/* <span>Premium Partner</span> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Alternative: Interactive Grid View for larger screens */}
      {/* <div className="brands-grid-container">
        <div className="brands-grid">
          {logos.slice(0, 8).map((logo, idx) => (
            <div key={idx} className="brands-grid-item">
              <div className="brands-grid-card">
                <img 
                  src={logo.image} 
                  alt={`Brand ${idx + 1}`} 
                  className="brands-grid-image"
                  loading="lazy"
                />
                <div className="brands-grid-hover">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 12H4M12 4v16" strokeLinecap="round"/>
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      {/* Trust Indicator */}
      {/* <div className="brands-trust">
        <div className="brands-trust-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
          <span>10+ Premium Brands</span>
        </div>
        <div className="brands-trust-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 16v-4M12 8h.01"/>
          </svg>
          <span>ISO Certified Partners</span>
        </div>
        <div className="brands-trust-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4"/>
          </svg>
          <span>Quality Assured</span>
        </div>
      </div> */}
    </section>
  );
};

export default BrandsSection;